type UseSkeltonLoaderWidthProps = {
  rowIndex: number
  modulo: number
  sampleWidthArray: Array<string>
}

export const useSkeltonLoaderWidth = ({
  rowIndex,
  modulo,
  sampleWidthArray,
}: UseSkeltonLoaderWidthProps) => {
  if (sampleWidthArray.length !== modulo) {
    throw new Error(
      `sampleWidthArray length should be equal to modulo. sampleWidthArray length: ${sampleWidthArray.length}, modulo: ${modulo}`
    )
  }

  const reminder = (rowIndex + 1) % modulo
  return sampleWidthArray[reminder]
}
